import React, { useEffect, useState, useMemo, useRef } from "react";
import "./transaction.scss";
import moment from "moment";
import { JSONTree } from "react-json-tree";
import {
  Button,
  DatePicker,
  message,
  Modal,
  notification,
  Popover,
  Select,
  Spin,
  Table,
  Tag,
  Tooltip,
} from "antd";
import {
  CalendarOutlined,
  DownloadOutlined,
  DownOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import transactionActions from "../../redux/transactions/actions";
import { CSVLink } from "react-csv";
import { BiDownArrow } from "react-icons/bi";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";
import { RiCodeSSlashFill, RiCodeSSlashLine } from "react-icons/ri";
import { RiCodeSLine } from "react-icons/ri";
import CountUp from "react-countup";
import TransactionExport from "./TransactionExport";

const {
  getTransactionsData,
  getAllTransactionsData,
  resetAllTransactionsData,
  getFullTransactionDetails,
  getFullTransactionsDetailsReset,
} = transactionActions;
function Transactions() {
  const dispatch = useDispatch();
  const { agentInformation } = useSelector((state) => state.authReducer);

  const {
    allTransactions,
    fullTransactionDetails,
    profileData,
    transactionData,
    totalData,
    loading,
  } = useSelector((state) => {
    return {
      allTransactions: state.transactionReducer?.allTransactions,
      fullTransactionDetails: state.transactionReducer?.fullTransactionDetails,
      profileData: state.authReducer.profileData,
      transactionData: state.transactionReducer?.transactionData,
      totalData: state.transactionReducer?.totalData,
      loading: state.transactionReducer?.loading,
    };
  });

  const agentId = profileData.orgId;
  const [search, setSearch] = useState("");
  const [fromDate, setFromDate] = useState(null);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [alertNotify, setAlertNotify] = useState(false);
  const [toggleTransactionDetailsModal, setToggleTransactionDetailsModal] =
    useState(true);
  const [userNotified, setUserNotified] = useState(false);
  const [toggleTransactionKey, setToggleTransactionKey] = useState("");
  const [newAgentInformation, setNewAgentInformation] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [tableParams, setTableParams] = useState({
    current: 1,
    pageSize: 10,
  });
  const [timeoutId, setTimeoutId] = useState(null);
  const [api, contextHolder] = notification.useNotification();
  const [copyCount, setCopyCount] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [Status, setStatus] = useState("");
  const { Option } = Select;

  const [Category, setCategory] = useState("");

  //for refund pages
  const navigate = useNavigate();

  const HandleChange = () => {
    navigate("/refund");
  };

  useEffect(() => {
    if (agentInformation?.data) {
      setNewAgentInformation(agentInformation);
    }
  }, [agentInformation?.data]);

  const getDynamicColumns = (transactions) => {
    const tags = [];

    // Iterate over all transactions to collect tags
    transactions?.forEach((transaction) => {
      transaction?.customerParams?.tag?.forEach((tag) => {
        // Avoid duplicates by checking if the tag name already exists
        if (!tags.some((existingTag) => existingTag?.name === tag?.name)) {
          tags.push(tag);
        }
      });
    });

    // Map tags to columns
    return tags?.map((tag) => ({
      title: tag?.name.toUpperCase(), // Column title will be the name of the tag
      dataIndex: tag?.name, // Column dataIndex will be the value (or unique identifier)
    }));
  };

  // Memoize the dynamic columns to avoid recalculating on every render
  const dynamicColumns = useMemo(
    () => getDynamicColumns(transactionData?.data?.transactions),
    [transactionData]
  );

  const uniqueStatuses = useMemo(() => {
    if (!transactionData?.data?.transactions) return [];
    return [
      ...new Set(
        transactionData.data.transactions.map((item) =>
          item.status.toLowerCase()
        )
      ),
    ];
  }, [transactionData]);

  const paymentModeOptions = [
    { text: "UPI", value: "upi" },
    { text: "Cash", value: "cash" },
    { text: "Credit Card", value: "credit card" },
    { text: "Account Transfer", value: "account transfer" },
    { text: "Internet Banking", value: "internet banking" },
    { text: "Debit Card", value: "debit card" },
    { text: "Prepaid Card", value: "prepaid card" },
    { text: "IMPS", value: "imps" },
    { text: "Wallet", value: "wallet" },
    { text: "NEFT", value: "neft" },
    { text: "AEPS", value: "aeps" },
    { text: "Others", value: "others" },
  ];

  const billerCategories = [
    { text: "Electricity", value: "electricity" },
    { text: "LPG", value: "lpg" },
    { text: "Gas", value: "gas" },
    { text: "Water", value: "water" },
    { text: "Municipal Taxes", value: "municipal taxes" },
    { text: "Housing Society", value: "housing society maintenance" },
    { text: "Rent", value: "rent" },
    { text: "Landline postpaid", value: "landline postpaid" },
    { text: "Mobile prepaid", value: "mobile prepaid" },
    { text: "Mobile postpaid", value: "mobile postpaid" },
    { text: "FASTag", value: "fastag" },
    { text: "NCMC", value: "ncmc" },
    { text: "Loan repayment", value: "loan repayment" },
    { text: "Credit card", value: "credit card" },
    { text: "Insurance", value: "insurance" },
    { text: "Health Insurance", value: "health insurance" },
    { text: "Recurring Deposit", value: "recurring Deposit" },
    { text: "Education Fees", value: "education fees" },
    { text: "Donation", value: "donation" },
    { text: "National Pension Scheme", value: "national pension scheme" },
    { text: "Broadband Postpaid", value: "broadband postpaid" },
    { text: "Cable TV", value: "cable tv" },
    { text: "DTH", value: "dth" },
    { text: "Subscriptions", value: "subscriptions" },
    { text: "Hospital & Pathology", value: "hospital & pathology" },
    { text: "Hospital", value: "hospital" },
  ];

  const columns = [
    {
      title: "S .NO",
      dataIndex: "key",
      key: "key",
      sorter: (a, b) => a?.key - b?.key,
      width: 100,
    },
    {
      title: "DATE-TIME",
      dataIndex: "date",
      sorter: (a, b) => Date?.parse(a?.createdAt) - Date?.parse(b?.createdAt), // Compare raw date-time
      width: 100, // Fixed width
      render: (text, record) => (
        <>
          <p className="m-0 p-0">
            {moment(record?.createdAt)?.format("DD MMMM YYYY")}
          </p>
          <p className="m-0 p-0">
            {moment(record?.createdAt)?.format("hh:mm:ss A")}
          </p>
        </>
      ),
    },

    {
      title: "TRANSACTION ID",
      dataIndex: "transaction_id",
      sorter: (a, b) => a.transaction_id.localeCompare(b.transaction_id),
    },
    {
      title: "PAYMENT MODE",
      dataIndex: "payment_mode",
      width: 150,

      render: (mode) => (
        <Tag>{mode.charAt(0).toUpperCase() + mode.slice(1)}</Tag>
      ),
    },

    {
      title: "BILLER",
      dataIndex: "biller_name",
    },
    {
      title: "PAID AMOUNT",
      dataIndex: "billAmount",
      sorter: (a, b) =>
        parseFloat(a?.billAmount?.replace(/[^0-9.-]+/g, "")) -
        parseFloat(b?.billAmount?.replace(/[^0-9.-]+/g, "")),
    },
    {
      title: "INTERCHANGE FEES",
      dataIndex: "InterchangeFee",
    },

    {
      title: "SWITCHING FEES ",
      dataIndex: "SwitchingFee",
    },

    // {
    //   title: "TOTAL COMMISSION AMOUNT",
    //   dataIndex: "totalCommisionamount",
    //   render: (value, record) => {
    //     const interchangeFee =
    //       parseFloat(record.InterchangeFee?.replace(/[^0-9.-]+/g, "")) || 0;
    //     const switchingFee =
    //       parseFloat(record.SwitchingFee?.replace(/[^0-9.-]+/g, "")) || 0;
    //     const totalCommission =
    //       parseFloat(record.totalCommisionamount?.replace(/[^0-9.-]+/g, "")) ||
    //       0;

    //     // if no value, show just "—" without tooltip
    //     if (!value || value === "—") {
    //       return <span style={{ color: "#999" }}>—</span>;
    //     }

    //     if (record?.biller_category_name === "Credit Card") {
    //       return <span >{value}</span>;
    //     } else {
    //       return (
    //         <Tooltip
    //           placement="top"
    //           color="white"
    //           overlayInnerStyle={{
    //             color: "black",
    //             fontSize: "13px",
    //             border: "1px solid #ddd",
    //             borderRadius: "6px",
    //             padding: "8px",
    //           }}
    //           title={
    //             <div>
    //               <div>IF - SF = C</div>
    //               <div>
    //                 ₹{interchangeFee} - ₹{switchingFee} = ₹{totalCommission}
    //               </div>
    //             </div>
    //           }
    //         >
    //           <span style={{ cursor: "pointer" }}>{value}</span>
    //         </Tooltip>
    //       );
    //     }
    //   },
    // },

    {
      title: `AI COMMISSION (${agentInformation?.data?.AICommissionPercent}%)`,
      dataIndex: "aiCommission",
      render: (value, record) => {
        const total = record.totalCommisionamount
          ? parseFloat(record.totalCommisionamount.replace(/[^0-9.-]+/g, ""))
          : 0;

        if (!value || value === "—") {
          return (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <span style={{ color: "#999" }}>—</span>
            </div>
          );
        }

        if (record?.biller_category_name === "Credit Card") {
          return (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <span>{value}</span>
            </div>
          );
        } else {
          return (
            <Tooltip
              placement="top"
              color="transparent" // removes AntD's black background
              overlayInnerStyle={{
                background: "transparent",
                boxShadow: "none",
              }} // extra safety
              title={
                <div
                  style={{
                    padding: "10px",
                    background: "white", // only white background
                    border: "1px solid #ddd",
                    borderRadius: "6px",
                    color: "black",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                    fontSize: "13px",
                  }}
                >
                  {agentInformation?.data?.AICommissionPercent}% of Total
                  Commission: ₹{total}
                </div>
              }
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                <span style={{ cursor: "pointer" }}>{value}</span>
              </div>
            </Tooltip>
          );
        }
      },
    },

    ...dynamicColumns?.map((item) => {
      // console.log(item.dataIndex,"index")
      // if (item.dataIndex.toLowerCase() === "acct-id") {
      //   return {
      //     ...item, // Spread existing column properties
      //     sorter: (a, b) => {
      //       // Add a sorter for the "acc-id" column
      //       return a['acc-id'] - b['acc-id'];
      //     },
      //   };
      // }
      return item; // Return the column unchanged if dataIndex doesn't match
    }),
    // {
    //   title: "PARTICIPANT CODE",
    //   dataIndex: "participant_code",
    // },

    // {
    //   title: "BILLER CATEGORY",
    //   dataIndex: "biller_category_name",
    //   width: 400,
    //   filters: billerCategoryOptions.map((mode) => ({
    //     text: mode.text.charAt(0).toUpperCase() + mode.text.slice(1),
    //     value: mode.value,
    //   })),
    //   onFilter: (value, record) => {
    //     if (value === "others") {
    //       return ![
    //         "broadband postpaid",
    //         "mobile postpaid",
    //         "cable tv",
    //         "electricity",
    //         "housing society",
    //         "dth",
    //         "gas",
    //         "subscription",
    //         "municipal taxes",
    //         "hospital",
    //         "water",
    //         "credit card",
    //         "fastag",
    //         "landline postpaid",
    //         "insurance",
    //         "loan repayment",
    //         "donation",
    //         "education fees",
    //         "b2b",
    //         "clubs and associations",
    //         "ncmc recharge",
    //         "recurring deposit",
    //         "hospital and pathology",
    //         "prepaid meter",
    //         "agent collection",
    //         "rental",
    //         "lpg gas",
    //         "life insurance",
    //         "mobile prepaid",
    //         "municipal services",
    //         "metro recharge",
    //         "corporate credit card",
    //         "echallan",
    //         "electricity prepaid",
    //         "broadband prepaid",
    //         "landline prepaid",
    //         "national pension scheme",
    //         "national pension system",
    //         "ops1",
    //         "mobile",
    //         "health insurance",
    //       ].includes(record.biller_category_name?.toLowerCase());
    //     }

    //     return record.biller_category_name?.toLowerCase() === value;
    //   },
    // },

    {
      title: "BILLER CATEGORY",
      dataIndex: "biller_category_name",
      width: 150,

      // This is just for visual feedback in the filtered column
      // filteredValue: searchQuery ? [searchQuery] : [],
      onFilter: (value, record) => {
        // Client-side filtering fallback (optional)
        const category = record.biller_category_name?.toLowerCase() || "";
        return category.includes(value.toLowerCase());
      },
    },
    // {
    //   title: "TRANSACTION STATUS",
    //   dataIndex: "status",
    //   width: 150, // Fixed width
    //   filters: uniqueStatuses.map((status) => ({
    //     text: status,
    //     value: status,
    //   })),
    //   onFilter: (value, record) => {
    //     const statusText = record.status.props.children; // Get plain text
    //     return statusText.toLowerCase() === value.toLowerCase();
    //   },
    //   render: (text, record) => (
    //     <Tag
    //       color={
    //         record?.status?.props?.children?.toLowerCase() === "successful"
    //           ? "green"
    //           : record?.status?.props?.children?.toLowerCase() === "pending"

    //           ? "yellow"
    //           : "red"
    //       }
    //     >
    //       {record.status.props.children}
    //     </Tag>
    //   ),
    // },
    {
      title: "TRANSACTION STATUS",
      dataIndex: "status",
      width: 150, // Fixed width
      onFilter: (value, record) => {
        const statusText = record.status.props.children; // Get plain text
        return statusText.toLowerCase() === value.toLowerCase();
      },
      render: (text, record) => (
        <Tag
          color={
            record?.status?.props?.children?.toLowerCase() === "successful"
              ? "green"
              : record?.status?.props?.children?.toLowerCase() === "pending"
              ? "yellow"
              : "red"
          }
        >
          {record.status.props.children}
        </Tag>
      ),
    },

    {
      title: "FULL TRANSACTION DETAILS",
      dataIndex: "allTransactionDetails",
    },
    // {
    //   title: "RESPONSE MESSAGE",
    //   dataIndex: "repsonse_msg",
    // },
  ];

  const handleViewTransactionDetails = (data) => {
    dispatch(getFullTransactionDetails(data.refId));
    setToggleTransactionDetailsModal(!toggleTransactionDetailsModal);
    setToggleTransactionKey(data.refId);
  };

  var data =
    transactionData?.data?.transactions &&
    transactionData?.data?.transactions?.length > 0 &&
    transactionData?.data?.transactions?.map((items, index) => {
      const customerTags = items?.customerParams?.tag || [];

      const rowData = {
        key: (tableParams.current - 1) * tableParams.pageSize + index + 1,
        transaction_id: items?.transactionId || "—",
        agentId: items?.agentId || "—",
        biller_name: items?.billerName || "—",
        biller_category_name: items?.billerCategoryName || "—",
        payment_mode: items?.paymentMode || "—",
        billAmount: items?.amount ? `₹${items?.amount / 100}` : "—",
        aiCommission: items?.aiCommission ? `₹${items?.aiCommission}` : "—",
        SwitchingFee: items?.switchingFee
          ? items?.billerCategoryName === "Credit Card"
            ? "—"
            : `₹${items?.switchingFee}`
          : "—",
        InterchangeFee: items?.interchangeFee
          ? items?.billerCategoryName === "Credit Card"
            ? "—"
            : `₹${items?.interchangeFee}`
          : "—",
        totalCommisionamount: items?.totalCommissionAmount
          ? `₹${items?.totalCommissionAmount}`
          : "—",
        date: items?.createdAt ? (
          <>
            <p className="m-0 p-0">
              {moment(items?.createdAt).format("DD MMMM YYYY")}
            </p>
            <p className="m-0 p-0">
              {moment(items?.createdAt).format("hh:mm:ss A")}
            </p>
          </>
        ) : (
          "—"
        ),
        createdAt: items?.createdAt || "-",
        status: (
          <Tag
            color={
              items?.status?.toLowerCase() === "successful"
                ? "green"
                : items?.status?.toLowerCase() === "pending"
                ? "yellow"
                : "red"
            }
            className="draft"
          >
            {items?.status
              ? items?.status.charAt(0).toUpperCase() + items?.status.slice(1)
              : "—"}
          </Tag>
        ),
        allTransactionDetails: (
          <span
            onClick={() => handleViewTransactionDetails(items)}
            style={{
              display: "flex",
              justifyContent: "center",
              cursor: "pointer",
            }}
          >
            {toggleTransactionDetailsModal === false &&
            toggleTransactionKey === items?.refId ? (
              <RiCodeSLine size={25} color="#073763" />
            ) : (
              <RiCodeSSlashLine size={25} />
            )}
          </span>
        ),
      };

      // Dynamically add customer tags, fallback to "-"
      customerTags?.forEach((tag) => {
        rowData[tag?.name] = tag?.value || "—";
      });

      return rowData;
    });

  console.log(data, "data---transactions--->");
  const handleSearch = (e) => {
    e.preventDefault();
    const value = e.target.value.trim(); // Trim the input value

    if (value && Category) {
      setCategory("");
    }
    setSearchQuery(value);

    // Update the search state

    // Clear the previous timeout
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    // Set a new timeout for debouncing
    const newTimeoutId = setTimeout(() => {
      if (value.length > 1) {
        dispatch(
          getTransactionsData(
            profileData.orgId,
            1,
            10,
            value,
            fromDate?.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
            toDate?.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
            Status
          )
        );
      }
    }, 1000); // 1-second delay for debouncing

    // Save the new timeout ID in state
    setTimeoutId(newTimeoutId);
  };
  const handlePageChange = async (pagination, filters, sorter) => {
    const { current, pageSize } = pagination;
    setTableParams({ current, pageSize });
    const filterChange = searchQuery ? searchQuery : Category;

    if (fromDate && toDate) {
      dispatch(
        getTransactionsData(
          profileData.orgId,
          current,
          10,
          filterChange,
          fromDate?.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
          toDate?.format("YYYY-MM-DDTHH:mm:ss.SSSZ"), // Ensures correct format,
          Status
        )
      );
    } else {
      dispatch(
        getTransactionsData(
          profileData.orgId,
          current,
          pageSize,
          filterChange,
          "",
          "",
          Status
        )
      );
    }
  };

  // const handleFilterChange = () => {
  //   setSearch("");
  //   dispatch(getTransactionsData(profileData.orgId, "", "", "", "", ""));
  // };

  const handleFromDateChange = (date) => {
    if (
      date?.isSame(moment(), "day") &&
      (date?.hour() > moment().hour() ||
        (date?.hour() === moment().hour() &&
          date?.minute() > moment().minute()) ||
        (date?.hour() === moment().hour() &&
          date?.minute() === moment().minute() &&
          date?.second() > moment().second()))
    ) {
      setFromDate(
        date
          .clone()
          .hour(moment().hour())
          .minute(moment().minute())
          .second(moment().second())
      );
    } else {
      setFromDate(date);
    }
    if (date > toDate) {
      setToDate(null);
    }
  };

  const handleToDateChange = (date) => {
    if (date?.isAfter(moment(), "day")) {
      setToDate(moment());
    } else if (date?.isSame(moment(), "day")) {
      if (
        date?.isSame(fromDate, "day") &&
        date?.hour() === 0 &&
        date?.minute() === 0 &&
        date?.second() === 0
      ) {
        setToDate(
          date
            .clone()
            .hour(moment().hour())
            .minute(moment().minute())
            .second(moment().second())
        );
      } else if (
        date?.isSame(fromDate, "day") &&
        (date?.hour() > moment().hour() ||
          (date?.hour() === moment().hour() &&
            date?.minute() > moment().minute()) ||
          (date?.hour() === moment().hour() &&
            date?.minute() === moment().minute() &&
            date?.second() > moment().second()))
      ) {
        setToDate(
          date
            .clone()
            .hour(moment().hour())
            .minute(moment().minute())
            .second(moment().second())
        );
      } else if (
        date?.hour() > moment().hour() ||
        (date?.hour() === moment().hour() &&
          date?.minute() > moment().minute()) ||
        (date?.hour() === moment().hour() &&
          date?.minute() === moment().minute() &&
          date?.second() > moment().second())
      ) {
        setToDate(
          date
            .clone()
            .hour(moment().hour())
            .minute(moment().minute())
            .second(moment().second())
        );
      } else {
        setToDate(date);
      }
    } else {
      if (
        date?.isSame(fromDate, "day") &&
        date?.hour() === 0 &&
        date?.minute() === 0 &&
        date?.second() === 0
      ) {
        setToDate(date.clone().hour(23).minute(59).second(59));
      } else {
        setToDate(date);
      }
    }
    if (date && date < fromDate) {
      setFromDate(null);
    }
  };

  const disabledToDate = (current) => {
    return (
      (fromDate && current && current < fromDate?.startOf("day")) ||
      current > moment().endOf("day")
    );
  };

  const disabledDate = (current) => {
    return current && current > moment().endOf("day");
  };

  const handleStatusChange = (value) => {
    setStatus(value);
    const filterChange = searchQuery ? searchQuery : Category;

    dispatch(
      getTransactionsData(
        agentId,
        1,
        10,
        filterChange,
        fromDate?.format("YYYY-MM-DD"),
        toDate?.format("YYYY-MM-DD"),
        value
      )
    );
  };
  const disabledTime = (currentDate) => {
    const now = moment();
    if (currentDate.isSame(now, "day")) {
      return {
        disabledHours: () =>
          Array.from({ length: 24 }, (_, i) => i).filter(
            (hour) => hour > now.hour()
          ),
        disabledMinutes: (selectedHour) => {
          if (selectedHour === now.hour()) {
            return Array.from({ length: 60 }, (_, i) => i).filter(
              (minute) => minute > now.minute()
            );
          }
          return [];
        },
        disabledSeconds: () => [],
      };
    }
    return {
      disabledHours: () => [],
      disabledMinutes: () => [],
      disabledSeconds: () => [],
    };
  };

  useEffect(() => {
    if (!fromDate && !toDate) {
      const filterChange = searchQuery ? searchQuery : Category;

      dispatch(
        getTransactionsData(
          profileData.orgId,
          1,
          10,
          filterChange,
          fromDate?.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
          toDate?.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
          Status
        )
      );
    } else if (fromDate && toDate) {
      const filterChange = searchQuery ? searchQuery : Category;

      dispatch(
        getTransactionsData(
          profileData.orgId,
          1,
          10,
          filterChange,
          fromDate?.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
          toDate?.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
          Status
        )
      );
    } else if (fromDate === null || toDate === null) {
      return;
    } else if (searchQuery || (Category && Status)) {
      const filterChange = searchQuery ? searchQuery : Category;
      dispatch(
        getTransactionsData(
          profileData.orgId,
          1,
          10,
          filterChange,
          fromDate?.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
          toDate?.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
          Status
        )
      );
    }

    // Reset the table params to default pagination state
    setTableParams((prev) => ({
      ...prev,
      current: 1,
      pageSize: 10,
    }));
  }, [
    profileData?.orgId,
    dispatch,
    fromDate,
    toDate,
    searchQuery,
    Category,
    Status,
  ]);

  useEffect(() => {
    dispatch(resetAllTransactionsData());
  }, [fromDate, toDate, dispatch, searchQuery, Category]);

  const openNotification = () => {
    sessionStorage.setItem("userNotified", true);
    setUserNotified(sessionStorage.getItem("userNotified"));
    api.open({
      message: (
        <div>
          🎉 You can now{" "}
          <span style={{ fontWeight: "bold", color: "green" }}>
            export the transaction file
          </span>{" "}
          with data filtered by the{" "}
          <span
            style={{
              color: "red",
              fontWeight: "bold",
              textDecoration: "underline",
            }}
          >
            Status
          </span>{" "}
          filter (if selected). Use the status dropdown to refine your export.
        </div>
      ),
      placement: "topRight",
      duration: 5,
      style: {
        width: 600,
      },
      onClose: () => {
        setAlertNotify(false);
      },
    });
    setAlertNotify(true);
  };

  // function to get all transactions data
  const functionToGetAllTransactionsData = () => {
    if (fromDate === null || toDate === null) {
      openNotification();
    } else {
      dispatch(
        getAllTransactionsData(
          profileData?.orgId,
          "",
          "",
          "",
          fromDate?.format("YYYY-MM-DD"),
          toDate?.format("YYYY-MM-DD")
        )
      );
    }
  };

  // Function to display the details dynamically
  const renderTransactionDetails = (data) => {
    if (!data || Object.keys(data).length === 0)
      return <span>No transaction details available.</span>;

    return Object.keys(data).map((key) => (
      <div key={key} style={{ marginBottom: "10px" }}>
        <strong>{key}:</strong> {JSON.stringify(data[key], null, 2)}{" "}
        {/* Displaying nested data in string format */}
      </div>
    ));
  };

  useEffect(() => {
    if (toggleTransactionDetailsModal) {
      setCopyCount(0);
    }
  }, [toggleTransactionDetailsModal]);

  const handleCopyClick = () => {
    if (copyCount < 3) {
      navigator?.clipboard
        ?.writeText(
          JSON.stringify(
            fullTransactionDetails?.data !== ""
              ? fullTransactionDetails?.data
              : {}
          )
        )
        ?.then(() => {
          message.success("Copied to clipboard!");
          setCopyCount(copyCount + 1);
        })
        .catch(() => {
          message.error("Failed to copy!");
        });
    }
  };

  // function to close the full transaction details modal
  const handleTransactionDetailsModalClose = () => {
    setToggleTransactionDetailsModal(true);
    dispatch(getFullTransactionsDetailsReset());
  };

  useEffect(() => {
    const filterChange = searchQuery ? searchQuery : Category;
    dispatch(
      getTransactionsData(
        profileData.orgId,
        1,
        10,
        filterChange,
        fromDate?.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
        toDate?.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
        Status
      )
    );
  }, [agentId, dispatch, toDate, fromDate, searchQuery, Category, Status]);

  return (
    <div className="mainContain">
      {contextHolder}
      <h1 className="transaction">Transactions</h1>
      <div className="datesearchFi">
        <div className="">
          <input
            style={{
              width: "350px",
              outline: "none",
              border: "none",
              padding: "4px 8px",
              borderRadius: "4px",
            }}
            value={searchQuery}
            type="text"
            placeholder="Search by ID, Name, Mode, Amount,Category"
            // className="inputSearch"

            onChange={handleSearch}
          />
        </div>
        <div className="right-section">
          <div style={{ width: 250 }}>
            <Select
              allowClear
              placeholder="Select Status"
              style={{ width: "100%", height: "33px" }}
              onChange={handleStatusChange}
              // Make it controlled
              options={[
                { label: "Successful", value: "Successful" },
                { label: "Failure", value: "Failure" },
                { label: "Pending", value: "Pending" },
              ]}
            />
          </div>
          <div className="inputfatef">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "white",
                borderRadius: "4px",
              }}
            >
              <DatePicker
                value={fromDate}
                style={{ width: "100%", border: "none" }}
                onChange={handleFromDateChange}
                disabledDate={disabledDate}
                placeholder="From(DD-MM-YYYY HH:mm:ss)"
                showNow={false}
                showTime
                format="DD-MM-YYYY HH:mm:ss"
                suffixIcon={
                  <CalendarOutlined
                    style={{ color: "rgba(22, 22, 22, 0.25)" }}
                  />
                }
              />
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "white",
                borderRadius: "4px",
              }}
            >
              <DatePicker
                value={toDate}
                style={{ width: "100%", border: "none" }}
                onChange={handleToDateChange}
                disabledDate={disabledToDate}
                placeholder="To(DD-MM-YYYY HH:mm:ss)"
                showNow={false}
                showTime={{
                  format: "HH:mm:ss",
                  disabledTime: disabledTime,
                }}
                format="DD-MM-YYYY HH:mm:ss"
                suffixIcon={
                  <CalendarOutlined
                    style={{ color: "rgba(22, 22, 22, 0.25)" }}
                  />
                }
              />
            </div>
          </div>
        </div>
      </div>
      <div className="cardClass">
        {transactionData?.data?.total > 0 && (
          <div className="cardpayment">
            <div>Total Transactions</div>
            <CountUp
              start={0}
              useIndianSeparators={true}
              end={transactionData?.data?.total}
            ></CountUp>
          </div>
        )}
        <div className="cardpayment">
          <div>Total Payment</div>
          <CountUp
            start={0}
            useIndianSeparators={true}
            prefix="₹"
            end={transactionData?.data?.totalAmount / 100}
          ></CountUp>
        </div>
        <div className="cardpayment">
          <div>Total Commission</div>
          <CountUp
            start={0}
            useIndianSeparators={true}
            end={transactionData?.data?.commission?.aiCommission}
            decimals={2}
          ></CountUp>
        </div>

        <TransactionExport
          status={Status}
          openNotification={openNotification}
          userNotified={userNotified}
        />
      </div>
      <div className="mt-3 ant-table-content">
        <Table
          columns={columns}
          dataSource={data}
          loading={transactionData?.loading}
          pagination={{
            total: transactionData?.data?.total,
            current: tableParams.current,
            pageSize: tableParams.pageSize,
            showSizeChanger: true,
            showQuickJumper: true,
            pageSizeOptions: ["10", "20", "50", "100", "200"],
          }}
          onChange={handlePageChange}
        />
      </div>
      {/* modal for full transaction logs */}
      <Modal
        title="Full Transaction Details"
        open={toggleTransactionDetailsModal === false}
        onOk={handleTransactionDetailsModalClose}
        onCancel={handleTransactionDetailsModalClose}
        width={700}
        centered
        maskClosable={false}
        footer={[
          <Button key="back" onClick={handleTransactionDetailsModalClose}>
            OK
          </Button>,
        ]}
      >
        <div className="py-2" style={{ position: "relative" }}>
          <Button
            key="copy"
            style={{
              position: "absolute",
              top: "20px",
              zIndex: 10,
              right: "30px",
            }}
            onClick={handleCopyClick} // On click, copy the content
            disabled={copyCount >= 3}
          >
            Copy
          </Button>
          <div
            className="bg-white border rounded border-black code-modal-div"
            style={{
              padding: "10px",
              height: "480px",
              overflowY: "auto",
              borderRadius: "10px",
            }}
          >
            {fullTransactionDetails?.loading === true ? (
              <span
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "480px",
                }}
              >
                <Spin />
              </span>
            ) : (
              <>
                {transactionData?.loading === false &&
                fullTransactionDetails?.data !== "" &&
                fullTransactionDetails?.error === null ? (
                  <JSONTree
                    data={
                      fullTransactionDetails?.data !== ""
                        ? fullTransactionDetails?.data
                        : {}
                    }
                    theme={"bright:inverted"}
                  />
                ) : (
                  <JSONTree data={{}} theme={"bright:inverted"} />
                )}
              </>
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default Transactions;
